(function (scope) {

scope.ClickCloseOpen = function (ClickCloseOpenEl, options) {
	if ($(ClickCloseOpenEl).hasClass ("click-close-open-inited")) {
		return;
	}
	/*
	options.onOpenStart = function (clickCloseOpen) {};
	options.onOpen = function (clickCloseOpen) {};
	options.onCloseStart = function (clickCloseOpen) {};
	options.onClose = function (clickCloseOpen) {};
	*/
	/* init start */
	var me = this;
	me._clickCloseOpen = $(ClickCloseOpenEl);
	me._clickCloseOpen.data ("ClickCloseOpen", me);
	me._options = options;
	me._groupId = me._clickCloseOpen.data ("auto-close-group-id");
	if (!me._groupId) me._groupId = "";
	var targetData = me._clickCloseOpen.data ("click-close-open-target");
	me._clickCloseOpenTarget = $(targetData);
	if (me._clickCloseOpenTarget.length > 1) {
		me._clickCloseOpenTarget = me._clickCloseOpen.parent ().find ("> " + targetData);
		if (!me._clickCloseOpenTarget.length) me._clickCloseOpenTarget = me._clickCloseOpen.parent ().parent ().find ("> " + targetData);
		if (!me._clickCloseOpenTarget.length) me._clickCloseOpenTarget = $(targetData);
	}
	me._origH = [];
	me._clickCloseOpenTarget.each (function () {
		$(this).css ("overflow", "hidden");
		me._origH.push ($(this).height ());
	});
	if (me._clickCloseOpen.hasClass ("clickable-area") && me._clickCloseOpen.find ("a.btn").length > 1) {
		$(me._clickCloseOpen).find ("a.btn").on ("click.ClickCloseOpen", function () {
			me.toggle.apply (me);
			return false;
		});
	} else {
		$(me._clickCloseOpen).on ("click.ClickCloseOpen", function () {
			me.toggle.apply (me);
			return false;
		});
	}
	me.toggle = function () {
		if (!me._clickCloseOpenTarget.height ()) {
			me.open.apply (me);
		} else {
			me.close.apply (me);
		}
	};
	me._clickCloseOpen.addClass ("click-close-open-inited");
	/* init end */
	me._openCallback;
	me._isBusy;
	me.open = function (isFast, callback = null, isAtInit = false) {
		// console.log ("ClickCloseOpen.open", me._isOpen, me._isBusy, me);
		if (!isAtInit && me._isOpen) return;
		if (!me._isBusy) {
			me._isBusy = true;
			me._openCallback = callback;
			var currentOpened;
			if (me._groupId) currentOpened = window ["click-close-open-" + me._groupId];
			// console.log ("ClickCloseOpen.open", currentOpened);
			if (me._groupId && currentOpened) {
				me._isBusy = false;
				currentOpened.close (isFast = false, callback = function () {
					me.open.apply (me);
				});
			} else {
				if (isFast) {
					me._clickCloseOpen.addClass ("open");
					me._clickCloseOpenTarget.addClass ("open");
					me._clickCloseOpenTarget.css ("overflow", "");
					me._clickCloseOpen.parent ().addClass ("click-opened-proxy");
					me.onOpen ();
				} else {
					me._clickCloseOpen.addClass ("opening");
					me._clickCloseOpenTarget.addClass ("opening");
					// me._clickCloseOpenTarget.css ("overflow", "");
					me._clickCloseOpen.parent ().addClass ("click-opening-proxy");
					me._clickCloseOpenTarget.each (function (i) {
						TweenMax.to (this, window.tweenDurationVeryQuick, {
							height: me._origH [i],
							onComplete: function () {
								me._clickCloseOpenTarget.css ({
									height: ""
								});
								me._origH [i] = me._clickCloseOpenTarget.height ();
								if (i == me._clickCloseOpenTarget.length - 1) {
									me._clickCloseOpen.removeClass ("opening");
									me._clickCloseOpenTarget.removeClass ("opening");
									me._clickCloseOpen.parent ().removeClass ("click-opening-proxy");
									me._clickCloseOpen.addClass ("open");
									me._clickCloseOpenTarget.addClass ("open");
									me._clickCloseOpen.parent ().addClass ("click-opened-proxy");
									$(window).trigger ("scroll");
								}
								me.onOpen.apply (me, [isAtInit]);
							}
						});
					});
					if (me._options && me._options.onOpenStart instanceof Function) me._options.onOpenStart (me);
				}
			}
		}
	};
	me._isOpen;
	me.onOpen = function (isAtInit = false) {
		me._isBusy = false;
		me._isOpen = true;
		// console.log ("ClickCloseOpen.onOpen", me);
		if (me._groupId) window ["click-close-open-" + me._groupId] = me;
		if (!isAtInit && me._clickCloseOpen.data ("auto-close-on-mouse-out")) {
			// me._clickCloseOpen.parent ().on ("mouseout.ClickCloseOpen", function () {
			// 	me.close ();
			// });
			var rect = me._clickCloseOpenTarget.parent () [0].getBoundingClientRect ();
			var rect2 = me._clickCloseOpenTarget [0].getBoundingClientRect ();
			// console.log ("!!!parent", me._clickCloseOpenTarget.parent () [0]);
			// console.log ("!!!", rect);
			$(window).off ("mousemove.ClickCloseOpen");
			$(window).on ("mousemove.ClickCloseOpen", function (e) {
				// console.log (e.clientX, e.clientY);
				if (e.clientX < rect2.left || e.clientX > rect2.right || e.clientY < rect2.top || e.clientY > rect2.bottom) {
					if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
						me.close ();
					}
				}
			});
		}
		if (me._openCallback && me._openCallback instanceof Function) me._openCallback ();
		if (me._options && me._options.onOpen instanceof Function) me._options.onOpen (me);
	};
	me._closeCallback;
	me.close = function (isFast, callback = null, isAtInit = false) {
		if (!isAtInit && !me._isOpen) return;
		if (!me._isBusy) {
			me._closeCallback = callback;
			me._origH = [];
			me._clickCloseOpenTarget.each (function () {
				me._origH.push ($(this).height ());
			});
			if (isFast) {
				me._clickCloseOpenTarget.height (0);
				me._clickCloseOpen.removeClass ("open");
				me._clickCloseOpenTarget.removeClass ("open");
				me._clickCloseOpenTarget.css ("overflow", "hidden");
				me._clickCloseOpen.parent ().removeClass ("click-opened-proxy");
				me.onClose (isAtInit);
			} else {
				me._clickCloseOpen.addClass ("closing");
				me._clickCloseOpenTarget.addClass ("closing");
				me._clickCloseOpen.parent ().addClass ("click-closing-proxy");
				TweenMax.to (me._clickCloseOpenTarget, window.tweenDurationVeryQuick, {
					height: 0,
					onComplete: function () {
						me._clickCloseOpen.removeClass ("closing");
						me._clickCloseOpenTarget.removeClass ("closing");
						me._clickCloseOpen.parent ().removeClass ("click-closing-proxy");
						me._clickCloseOpen.removeClass ("open");
						me._clickCloseOpenTarget.removeClass ("open");
						me._clickCloseOpenTarget.css ("overflow", "hidden");
						me._clickCloseOpen.parent ().removeClass ("click-opened-proxy");
						$(window).trigger ("scroll");
						me.onClose.apply (me, [isAtInit]);
					}
				});
				if (me._options && me._options.onCloseStart instanceof Function) me._options.onCloseStart (me);
			}
		}
	};
	me.onClose = function (isAtInit = false) {
		me._isBusy = false;
		me._isOpen = false;
		// console.log ("ClickCloseOpen.onClose", me);
		if (!isAtInit && me._groupId) window ["click-close-open-" + me._groupId] = null;
		$(window).off ("mousemove.ClickCloseOpen");
		if (me._closeCallback && me._closeCallback instanceof Function) me._closeCallback ();
		if (me._options && me._options.onClose instanceof Function) me._options.onClose (me);
	};
	if (!me._clickCloseOpen.hasClass ("start-open")) me.close (true, null, true);
	else {
		me.open (true, null, true);
	}
}
	
}) (window);
